import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendIntegrationAuthorizationRequestInfo,
  BackendQueryIntegrationAuthorizationRequestInfoArgs,
} from 'src/types/backend';

import { INTEGRATION_REQUEST_INFO_FRAGMENT } from './schema';

const QUERY = gql`
  query IntegrationAuthorizationRequestInfo(
    $dataSource: PerformanceCenterDataSource!
    $customerId: ID
  ) {
    integrationAuthorizationRequestInfo(dataSource: $dataSource, customerId: $customerId) {
      ...IntegrationAuthorizationRequestInfo
    }
  }
  ${INTEGRATION_REQUEST_INFO_FRAGMENT}
`;

type Variables = BackendQueryIntegrationAuthorizationRequestInfoArgs;
type Result = BackendIntegrationAuthorizationRequestInfo;

export const queryIntegrationAuthorizationRequestInfo = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
